module.exports = "/_next/static/images/BusinessPlan-xs-3ce8969dadaf5e54d6a2137acf1fddfa.png";